<template>
  <!-- //代号20220921-1 -->
  <!-- 配置设备参数页面的内容区域 -->

  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">

      <config-title-hang>
        <span slot="config_title_hang_ele2">{{ brandName }}</span>
        <input slot="config_title_hang_ele8" type="text" placeholder="快速搜索" v-model="scerchValue" />
      </config-title-hang>

      <!-- 服务器返回的所有区域列表 -->
      <config-hang v-for="(value, index) in BrandModelBcList" :key="index" @click.native="selectBcBtnHandle(value)"
        :selectState="selectBcId === value.bcId">

        <span slot="config_hang_ele2_1">{{ value.modelName }} </span>
        <span slot="config_hang_ele2_2">{{ value.remarks }} </span>
        <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
        <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
      </config-hang>

      <div class="xiaotishi_style">当前设备产品码和信息码:[{{ $route.query.productCode }}|{{ $route.query.program }}]</div>
      <div class="xiaotishi_style">
        小提示：选择一个可用的配置项，点击保存并返回，可将配置项数据下载到本地设备。
      </div>

      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
    </div>
  </div>

</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";

import { mediumslateblue } from "color-name";

export default {
  data() {
    return {
      scerchValue: "", // 搜索使用
      BrandModelBcList: [],
      BrandModelBcListDataBack: [],//搜索使用
      brandName: "功能配置",
      selectBcId: 0,//选中的BC项id
      selectBcNum: 1,//选中的配置项BC规则条数
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },
  methods: {
    configGoPreviousPageHandle() {
      ////返回上一级的按钮  返回上一级  不保存当前勾选项
      this.$router.go(-1);
    },
    selectBcBtnHandle(value) {
      console.log("111111");
      console.log(value);
      this.selectBcId = value.bcId
      this.selectBcNum = value.bcNum
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      // 提交服务器之前对数据进行检查
      if (this.selectBcId == null || this.selectBcId == 0) {
        this.$toast('请选择一个配置项再保存！')
        return
      }
      /////保存下载规则到服务器及底层
      let requestSceneTimeout = this.selectBcNum * 600 + 6000 ////规则下载超时时间的计算 
      console.log(requestSceneTimeout)


      this.$store.dispatch('asyUpdataRequestSceneTimeout', requestSceneTimeout) ///异步提交场景超时时间到仓库
      this.$requestSceneRule({
        method: 'post',
        url: '/product/sendBcCommand',
        timeout: requestSceneTimeout,
        data: {
          token: this.$store.state.token,
          productId: this.$route.query.productId,
          bcId: this.selectBcId

        }
      })
        .then(res => {
          console.log(res.data)
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            this.$showTipsToast(1, '下载配置数据成功！', true) ////提示框
            this.$router.go(-1)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow(charData) {
      if (
        this.BrandModelBcList
      ) {
        //数据是合法存在的  添加备份数据
        this.BrandModelBcList = this.BrandModelBcList.concat(
          this.BrandModelBcListDataBack
        );
        this.BrandModelBcListDataBack.length = 0;

        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.BrandModelBcList.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              (this.BrandModelBcList[i].brandName + this.BrandModelBcList[i].modelName).indexOf(charData) == -1
            ) {
              // && this.BrandModelBcList[i].checked == false
              // 说明没有这个字符
              this.BrandModelBcListDataBack.push(
                this.BrandModelBcList[i]
              );
              this.BrandModelBcList.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.BrandModelBcList);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created() {
    console.log("created阶段");
    console.log("传过来的参数产品id和选中BCid" + this.$route.query.productId);
    console.log(this.$route.query);
    this.BrandModelBcList = this.$route.query.brandData.modelList;
    this.brandName = this.$route.query.brandData.brandName;
    this.selectBcId = this.$route.query.brandData.selectBcId
    // 根据上个页面传过来的BCid找到对应的BCnum 更新BCbum  用于下发时间计算
    for (let i = 0; i < this.BrandModelBcList.length; i++) {
      if (this.BrandModelBcList[i].bcId == this.selectBcId) {
        this.selectBcNum = this.BrandModelBcList[i].bcNum
      }
    }

  },
};
</script>

<style></style>
